import {StyleSheet} from "aphrodite";

import {color} from "@khanacademy/wonder-blocks-tokens";

export default StyleSheet.create({
    redText: {
        color: color.red,
    },
});
